import React from "react";
import { useTranslation } from "react-i18next";

export default function Convenience() {
  const { t } = useTranslation();
  return (
    <div className="convenience-div">
      <h3 className="convenience-head">
      {t("tucson.convenience1")}
      </h3>
      <p className="convenience-par container">
      {t("tucson.convenience2")}

      </p>
      {/* <img
        src="https://www.hyundai.com/content/dam/hyundai/template_en/en/images/find-a-car/pip/tucson-2021/convenience/tucson-nx4-fmc-convenience-your-digital-journey-starts-here-pc.jpg"
        alt="tucson"
      /> */}
<video width="900" controls muted loop autoPlay={true}>
          <source
            src="https://www.hyundai.com/content/dam/hyundai/ww/en/images/find-a-car/pip/suv/tucson-nx4-2023/convenience/video/tucson-convenience-headup-film.mp4"
            type="video/mp4"
          />
        </video>
      <div className="tucson-conv-parth">
        <div>
          <img
            src="https://www.hyundai.com/content/dam/hyundai/ww/en/images/find-a-car/pip/suv/tucson-nx4-2023/safety/tucson-safety-bvm-pc.jpg"
            alt="tucson"
            />
          <h3>      {t("tucson.convenience3")}</h3>
        </div>
        <div>
          <img
            src="https://www.hyundai.com/content/dam/hyundai/ww/en/images/find-a-car/pip/suv/tucson-nx4-2023/safety/tucson-safety-svm-pc.jpg"
            alt="tucson"
            />
          <h3>      {t("tucson.convenience4")}
</h3>
        </div>
      </div>
      <div className="tucson-conv-parth">
        <div>
          <img
            src="https://www.hyundai.com/content/dam/hyundai/ww/en/images/find-a-car/pip/suv/tucson-nx4-2023/safety/tucson-safety-roa-pc.jpg"
            alt="tucson"
            />
          <h3>
          {t("tucson.convenience5")}

          </h3>
        </div>
        <div>
          <img
            src="https://www.hyundai.com/content/dam/hyundai/ww/en/images/find-a-car/pip/suv/tucson-nx4-2023/safety/tucson-safety-spw-pc.jpg"
            alt="tucson"
            />
          <h3>      {t("tucson.convenience6")}
</h3> 
        </div>
      </div>
      <div className="tucson-end-part-conv">
        <h3 className="convenience-head">
        {t("tucson.convenience7")}
        </h3>
        {/* <p className="convenience-par">
        {t("tucson.convenience8")}

        </p> */}
        <img
          src="https://www.hyundai.com/content/dam/hyundai/ww/en/images/find-a-car/pip/suv/tucson-nx4-2023/convenience/tucson-convenience-main-pc.jpg"
          alt="tucson"
          />
      </div>
    </div>
  );
}
